/**
 * Platform-wide count formatting:
 * - under 1,000 → full number with locale commas when needed (e.g. 847)
 * - 1,000+ → compact K / M (e.g. 1.2K, 15K, 1.5M)
 */
export function formatCount(n) {
  const num = Math.round(Number(n) || 0);
  if (num >= 1_000_000) {
    const v = num / 1_000_000;
    const s = (v >= 10 ? v.toFixed(0) : v.toFixed(1)).replace(/\.0$/, "");
    return `${s}M`;
  }
  if (num >= 1000) {
    const v = num / 1000;
    const s = (num >= 10000 ? v.toFixed(0) : v.toFixed(1)).replace(/\.0$/, "");
    return `${s}K`;
  }
  return num.toLocaleString("en-US");
}
